import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Константы места параллакс-баннера между объявлениями.
 * Должны совпадать с легаси-размещением Adfox (ParallaxBanner): для новостроечной
 * и обычной выдачи разные p1.
 */
const PLACE = 'between_offers';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'bvkoa', p2: 'y' };
const P_PARAMS_NEWBUILDING: TAdBannerPlaceParameters['pParams'] = { p1: 'dazap', p2: 'y' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 560 };

interface IUseParallaxParametersParams {
  position: number;
  isNewbuilding: boolean;
}

/**
 * Параметры места параллакс-баннера (desktop).
 */
export function useParallaxParameters({
  position,
  isNewbuilding,
}: IUseParallaxParametersParams): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      place: PLACE,
      pParams: isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS,
      sizes: SIZES,
      position,
      galleryPosition: null,
      isSp: false,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType: 'desktop',
    }),
    [isNewbuilding, position],
  );
}
